module.exports = __webpack_public_path__ + "img/hua2@2x.0c579311.png";